import React from "react";

interface ThemeToggleProps {
  theme: "dark" | "light";
  onToggle: () => void;
  compact?: boolean;
}

export function ThemeToggle({ theme, onToggle, compact = false }: ThemeToggleProps) {
  return (
    <button
      onClick={onToggle}
      className="flex items-center gap-2 rounded-lg transition-all duration-200"
      style={{
        padding: compact ? "6px" : "6px 12px",
        color: "var(--c-text-secondary)",
      }}
      onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "var(--c-hover)")}
      onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "")}
      title={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
    >
      {theme === "dark" ? (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
        >
          <circle cx="8" cy="8" r="3.5" />
          <path d="M8 1.5v1M8 13.5v1M1.5 8h1M13.5 8h1M3.4 3.4l.7.7M11.9 11.9l.7.7M3.4 12.6l.7-.7M11.9 4.1l.7-.7" />
        </svg>
      ) : (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
        >
          <path d="M13.5 8.5a5.5 5.5 0 01-7.5-7.5 6 6 0 107.5 7.5z" />
        </svg>
      )}
      {!compact && <span className="text-xs">{theme === "dark" ? "Light" : "Dark"}</span>}
    </button>
  );
}
